import { MemberDto } from '@careapp-group/ng-sdk';
import { createReducer, on } from '@ngrx/store';
import { Conversations } from '../actions/index';
import { StreamAction } from '../stream/stream.actions';

export interface ConversationsStateInterface {
  loading: boolean;
  members: MemberDto[];
  error: string;
  unreadCount: number;
}
export const INITIAL_CONVERSATIONS_STATE: ConversationsStateInterface = {
  loading: false,
  members: [],
  error: '',
  unreadCount: 0,
};

export const conversationsReducer = _conversationsReducerFactory(window);

export function _conversationsReducerFactory(_window) {
  return createReducer<ConversationsStateInterface>(
    INITIAL_CONVERSATIONS_STATE,

    on(Conversations.requestConversationMembers, (state, action) => ({ ...state, loading: true })),
    on(Conversations.responseSuccessConversationMembers, (state, action) => ({
      ...state,
      loading: false,
      members: action.members,
    })),
    on(Conversations.responseFailConversationMembers, (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
    })),

    on(Conversations.requestStartConversation, (state, action) => ({
      ...state,
      loading: true,
    })),
    on(Conversations.responseSuccessStartConversation, (state, action) => ({
      ...state,
      loading: false,
    })),
    on(Conversations.responseFailStartConversation, (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
    })),

    on(Conversations.requestDisconnectConversations, (state, action) => ({
      ...state,
      loading: true,
    })),
    on(
      Conversations.responseSuccessDisconnectConversations,
      (state, action) => INITIAL_CONVERSATIONS_STATE,
    ),
    on(Conversations.responseFailDisconnectConversation, (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
    })),
    on(Conversations.updateUnreadConversationCount, (state, action) => ({
      ...state,
      unreadCount: action.count,
    })),

    on(Conversations.requestAddChannelModerators, (state, action) => ({
      ...state,
      loading: true,
    })),
    on(Conversations.responseSuccessAddChannelModerators, (state, action) => ({
      ...state,
      loading: false,
    })),
    on(Conversations.responseFailAddChannelModerators, (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
    })),

    on(Conversations.requestDemoteChannelModerator, (state, action) => ({
      ...state,
      loading: true,
    })),
    on(Conversations.responseSuccessDemoteChannelModerator, (state, action) => ({
      ...state,
      loading: false,
    })),
    on(Conversations.responseFailDemoteChannelModerator, (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
    })),
  );
}
